import React from 'react';
import { CONFIG } from 'config/config';


import styled from 'styled-components/macro';

const OptionBtn = styled.button`
	cursor: pointer;
	font-size: ${CONFIG.fontSizes.md};
	font-family: ${(props) => {
		if (props.selected) {
			return CONFIG.fonts.semiBold;
		} else {
			return CONFIG.fonts.regular;
		}
	}};
	background-color: ${(props) => {
		if (props.selected) {
			return CONFIG.colors.primary;
		} else {
			return CONFIG.colors.greyLight;
		}
	}};
	color: ${(props) => {
		if (props.selected) {
			return CONFIG.colors.white;
		} else {
			return CONFIG.colors.black;
		}
	}};
	border: ${(props) => {
		if (!props.selected) {
			return '0px';
		} else {
			return `1px solid ${CONFIG.colors.primaryDark}`;
		}
	}};
	border-radius: 3px;
	width: ${(props) => {
		if (!props.width) {
			return '170px';
		} else if (props.width === 'auto') {
			return 'auto';
		} else {
			return ` ${props.width}px`;
		}
	}};
	padding: 12px 12px;
	text-align: center;
	outline: none;

	:focus {
		background-color: ${CONFIG.colors.primaryLight};
		color: ${CONFIG.colors.black};
		border-bottom: 5px solid ${CONFIG.colors.primary} !important;
		outline: none;
	}

	:hover {
		opacity: 0.7;
	}

	:disabled {
		opacity: 0.5;
		cursor: default;
	}

	transition: 0.2s all;
`;

export const OptionButton = ({ style, onClick, selected, text, width }) => {
	return (
		<OptionBtn
			style={style}
			onClick={onClick}
			selected={selected}
			width={width || style?.width || 142}
		>
			{text}
		</OptionBtn>
	);
};
